import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { Dialog } from './Dialog';

export interface ConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    /** The action with its object: Delete "Lunch menu"? */
    title: string;
    /** One sentence of consequence, rendered as text. */
    children: ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    busy?: boolean;
}

/** Irreversible actions only. Initial focus is on Cancel. */
export const ConfirmDialog = ({ open, onClose, onConfirm, title, children, confirmLabel, cancelLabel, busy }: ConfirmDialogProps) => {
    const { t } = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={title}
            busy={busy}
            footer={
                <>
                    <Button variant="quiet" onClick={onClose} disabled={busy} data-autofocus>
                        {cancelLabel ?? t('ui.cancel')}
                    </Button>
                    <Button variant="danger" onClick={onConfirm} loading={busy}>
                        {confirmLabel ?? t('ui.delete')}
                    </Button>
                </>
            }
        >
            <p className="break-words text-small text-body">{children}</p>
        </Dialog>
    );
};
